import React from 'react';
import styled from 'styled-components';

const MedalWrapper = styled.div`
    display: flex;
    flex-direction: column;
    font-size: 11px;
    text-align: center;
    margin-right: 10px;
    text-transform: uppercase;
`;


const MEDAL_COLOR = {
    gold: '#F2BA4C',
    silver: '#D4D4D4',
    bronze: '#D69B65',
}
export const Medal = ({
    medalClass,
    label
})=>{
    return (
        <MedalWrapper>
        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.10167 0.9375L13.1378 7.67578C10.681 8.06641 8.53623 9.10156 6.70342 10.7812L0.210579 1.46484C-0.0233976 1.15234 -0.0623936 0.839844 0.0935905 0.527344C0.288571 0.175781 0.581041 0 0.971001 0H7.46384C7.81481 0 8.12677 0.078125 8.39974 0.234375C8.67272 0.390625 8.90669 0.625 9.10167 0.9375Z" fill="#686868"/>
        <path d="M22.5553 0H29.0481C29.4381 0 29.7111 0.175781 29.8671 0.527344C30.062 0.839844 30.0425 1.15234 29.8086 1.46484L23.3157 10.7812C21.4829 9.10156 19.3381 8.06641 16.8814 7.67578L20.9175 0.9375C21.1125 0.625 21.3464 0.390625 21.6194 0.234375C21.8924 0.078125 22.2043 0 22.5553 0Z" fill="#686868"/>
        <path d="M9.8036 10.7812C11.4024 9.84375 13.1378 9.375 15.0096 9.375C16.8814 9.375 18.5972 9.84375 20.157 10.7812C21.7559 11.6797 23.0038 12.9297 23.9007 14.5313C24.8366 16.0938 25.3045 17.8125 25.3045 19.6875C25.3045 21.5625 24.8366 23.3008 23.9007 24.9023C23.0038 26.4648 21.7559 27.6953 20.157 28.5938C18.5972 29.5313 16.8814 30 15.0096 30C13.1378 30 11.4024 29.5313 9.8036 28.5938C8.24376 27.6953 6.99589 26.4648 6.05998 24.9023C5.16307 23.3008 4.71462 21.5625 4.71462 19.6875C4.71462 17.8125 5.16307 16.0938 6.05998 14.5313C6.99589 12.9297 8.24376 11.6797 9.8036 10.7812Z" fill="#686868"/>
        <circle cx="15" cy="19.7368" r="10.2632" fill={MEDAL_COLOR[medalClass]}/>
        </svg>
        {label}
        </MedalWrapper>

    )
}
